import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=37375002&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=37375002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37375002",
  null
  
)

export default component.exports